import { render, staticRenderFns } from "./MpMillionairesV2.vue?vue&type=template&id=6b503c1c&scoped=true&"
import script from "./MpMillionairesV2.vue?vue&type=script&lang=js&"
export * from "./MpMillionairesV2.vue?vue&type=script&lang=js&"
import style1 from "./MpMillionairesV2.vue?vue&type=style&index=1&id=6b503c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b503c1c",
  null
  
)

export default component.exports